export default __webpack_public_path__ + "media/bundles/App/layout/icon/svgs/file-archive-d8823c26797742592b764a5613f9922f.svg";